// @flow
import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import layoutSaga from './layout/saga';
import hospitalSaga from './hospital/saga';
import issueTypeSaga from './issueType/saga'
import serviceOptionSaga from './serviceOption/saga';
import teamSaga from './team/saga';
import productSaga from './product/saga';
import requestFeatureSaga from './requestFeature/saga';
import userSaga from './user/saga';
import menuSaga from './menu/saga';
import privillegeSaga from './privillege/saga';
import sprintSaga from './sprint/saga';
import commentSaga from './comment/saga';
import workScheduleSaga from './workSchedule/saga';
import teamShiftAssignmentSaga from './teamShiftAssignment/saga'

export default function* rootSaga() {
    yield all([
        authSaga(),
        layoutSaga(),
        hospitalSaga(),
        issueTypeSaga(),
        serviceOptionSaga(),
        teamSaga(),
        productSaga(),
        requestFeatureSaga(),
        userSaga(),
        menuSaga(),
        privillegeSaga(),
        sprintSaga(),
        commentSaga(),
        workScheduleSaga(),
        teamShiftAssignmentSaga(),
    ]);
}
